import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import UserEventsList from '../components/userEvents/UserEventsList'
import cookies from '../utils/cookies'

export default function UserEventsPage({ building }) {
  let loggedUser
  const getLoggedUser = () => {
    try {
      const user = cookies.get('user')
      return JSON.parse(user)
    } catch (e) {
      return null
    }
  }
  if (building) {
    loggedUser = getLoggedUser()
  }
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <UserEventsList building={building ? loggedUser.building : null} />
      </Container>
    </main>
  )
}
